<template>
  <TopBarLayout :loading="loading" :data-length="boards.length">
    <template #title>
      <span>
        Kanban Boards
        <HelpPageBtn color="white" :page="__guide.kanban" />
      </span>
    </template>

    <template #header> <KanbanHeader /> </template>
    <template #content-data> <KanbanContent /> </template>
  </TopBarLayout>
</template>

<script>
import BoardsStoreModule from './vuex/BoardsStoreModule'
// Components
import KanbanHeader from './components/KanbanHeader'
import KanbanContent from './components/KanbanContent'
import TopBarLayout from '@/reusable/TopBarLayout/TopBarLayout'
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'
// Libraries
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  components: {
    KanbanHeader,
    KanbanContent,
    TopBarLayout,
    HelpPageBtn
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapState('boards', ['boards'])
  },

  beforeCreate() {
    this.$store.registerModule('boards', BoardsStoreModule)
  },

  async created() {
    this.loading = true
    await this.getAndSetBoards()
    this.loading = false
  },

  beforeDestroy() {
    this.resetState()
    this.$store.unregisterModule('boards')
  },

  methods: {
    ...mapMutations('boards', ['resetState']),
    ...mapActions('boards', ['getAndSetBoards'])
  }
}
</script>
